import React from "react";

const PlayBadge = ({ url }) => (
  <a className="btn btn-primary" href={url} target="_blank" rel="noreferrer">
    ▶ Get it on Google Play
  </a>
);

export default PlayBadge;
